// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { type Message } from '@ag-ui/client';
import { type ApiChatMessage, EnumChatMessageRole } from '@Model';

/** Maps a stored message onto the AG-UI wire shape the agent resumes from. */
export function toAgentMessage(message: ApiChatMessage): Message {
    const base = { id: message.id, content: message.content };

    switch (message.role) {
        case EnumChatMessageRole.User:
            return { ...base, role: 'user' };
        case EnumChatMessageRole.Tool:
            return { ...base, role: 'tool', toolCallId: message.tool_call_id ?? '' };
        case EnumChatMessageRole.System:
            return { ...base, role: 'system' };
        case EnumChatMessageRole.Assistant:
        default:
            return {
                ...base,
                role: 'assistant',
                ...(message.tool_calls.length > 0 && {
                    toolCalls: message.tool_calls.map((call) => ({
                        id: call.id,
                        type: 'function' as const,
                        function: { name: call.name, arguments: call.arguments },
                    })),
                }),
            };
    }
}
